import AddMeetingBoxLabel from "./add-meeting-box-label";
import MeetingRow from "./meeting-row";
import MeetingTabs from "./meeting-tabs";

export default { AddMeetingBoxLabel, MeetingRow, MeetingTabs };
